"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listConsult = listConsult;
exports.listConsults = listConsults;
exports.deleteConsult = deleteConsult;
exports.updateConsult = updateConsult;
exports.createConsult = createConsult;
exports.enableConsult = enableConsult;
exports.topConsultList = topConsultList;

var _request = _interopRequireDefault(require("@/utils/request"));

function listConsult(status) {
  return (0, _request.default)({
    url: '/workerOrderConsult/list',
    method: 'get',
    params: {
      isShowDeleted: status
    }
  });
}

function listConsults() {
  return (0, _request.default)({
    url: '/workerOrderConsult/listConsults',
    method: 'get'
  });
}

function deleteConsult(data) {
  return (0, _request.default)({
    url: '/workerOrderConsult/delete',
    method: 'post',
    data: {
      id: data
    }
  });
}

function updateConsult(data) {
  return (0, _request.default)({
    url: '/workerOrderConsult/update',
    method: 'post',
    data: data
  });
}

function createConsult(data) {
  return (0, _request.default)({
    url: '/workerOrderConsult/create',
    method: 'post',
    data: data
  });
}

function enableConsult(data) {
  return (0, _request.default)({
    url: '/workerOrderConsult/enable',
    method: 'post',
    data: data
  });
}

function topConsultList() {
  return (0, _request.default)({
    url: '/workerOrderConsult/getTopTicketType',
    method: 'get'
  });
}